// extracted by mini-css-extract-plugin
export default {"Button_0":"OperatorSelect-module__Button_0--JzNkw","Octicon_0":"OperatorSelect-module__Octicon_0--t_v4X"};